import { fromJS  } from 'immutable';

export const State = fromJS({
  isPosting: false,
  isPutting: false,
  isDeleting: false,
  errMsg: '',
  isGettingCaseRelated: false,
  caseRelateList: []
});